<template>
  <q-btn
    :label="label"
    :push="isActive"
    :unelevated="isActive"
    :color="isActive ? 'primary' : undefined"
    v-bind="$attrs"
    @click="onClick"
  />
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import { QBtn } from 'quasar';

export default defineComponent({
  emits: ['update:modelValue'],
  components: { QBtn },
  props: {
    modelValue: {
      type: Array as () => string[],
      required: true,
    },
    label: {
      type: String,
      required: false,
    },
    types: {
      type: Array as () => string[],
      required: true,
    },
  },
  computed: {
    isActive(): boolean {
      return this.eq(this.modelValue, this.types);
    },
  },
  methods: {
    eq(a: string[], b: string[]) {
      if (a.length !== b.length) return false;
      for (let i = 0; i < a.length; i += 1) if (a[i] !== b[i]) return false;
      return true;
    },
    onClick() {
      this.$emit('update:modelValue', this.types);
    },
  },
});
</script>
